module.exports = __webpack_public_path__ + "assets/img/046201.1cb6e505.png";